<template>
  <v-app class="app-user-wrapper">
    <Navbar />
<v-main>
  <div class="user-content" :class="{ 'user-content--mobile': $vuetify.breakpoint.smAndDown }">
    <router-view />
  </div>
</v-main>
    <UserFloatingChat />
    <Footer />
  </v-app>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";
import UserFloatingChat from "@/components/Chat/UserFloatingChat.vue";

export default {
  name: "DefaultLayout",
  components: { Navbar, Footer, UserFloatingChat },
};
</script>

<style scoped>
.app-user-wrapper {
  max-width: 100vw;
  overflow-x: hidden !important;
}

.user-content {
  min-height: calc(100vh - 64px);
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
  padding-top: 10px; /* Small breathing room for pages */
}

/* Push content up above the fixed bottom nav bar + iOS safe area */
.user-content--mobile {
  padding-top: 4px; /* Less top padding on mobile */
  padding-bottom: calc(72px + env(safe-area-inset-bottom, 0px));
}

/* Global mobile-friendly adjustments for inner generic containers handled by Vuetify */
::v-deep .v-container {
  max-width: 100%;
}
</style>
